var $0bc56cee3275bcaa$exports = {};
$0bc56cee3275bcaa$exports = {
  "close": "Zapri",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " obvestilo");
      },
      two: function two() {
        return "".concat(formatter.number(args.count), " obvestili");
      },
      few: function few() {
        return "".concat(formatter.number(args.count), " obvestila");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " obvestil");
      }
    }), ".");
  }
};
export { $0bc56cee3275bcaa$exports as default };